import React from 'react'
import { Spinner } from 'react-bootstrap'
import './LoadingOverlay.scss'

interface LoadingOverlayProps {
  show: boolean
  message?: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, message = 'Loading...' }) => {
  if (!show) {
    return null
  }

  return (
    <div className='loading-overlay'>
      <div className='loading-overlay-content'>
        <Spinner animation='border' variant='light' />
        <div className='loading-message'>{message}</div>
      </div>
    </div>
  )
}
